import * as t from "io-ts";
import { UnreachableVariantError } from "../../unreachable-variant-error";

export const AbbuchungsintervallKurz = t.keyof({
  "T": null,
  "E": null,
  "M": null,
  "M2": null,
  "Q": null,
  "M4": null,
  "H": null,
  "J": null,
});
export type AbbuchungsintervallKurz = t.TypeOf<typeof AbbuchungsintervallKurz>;

export function printTextAbbuchungsintervall(value: AbbuchungsintervallKurz, rhythmus: number): string {
  switch (value) {
    case "T":
      if (rhythmus > 0) {
        return `${rhythmus * 7}-tägig`;
      }
      return "wöchentlich";
    case "E": return "einmalig";
    case "M": return "monatlich";
    case "M2": return "alle 2 Monate";
    case "Q": return "alle 3 Monate";
    case "M4": return "alle 4 Monate";
    case "H": return "alle 6 Monate";
    case "J": return "jährlich";
    default: throw new UnreachableVariantError(value);
  }
}

export function printTextAbbuchungsintervallShort(value: AbbuchungsintervallKurz, rhythmus: number): string {
  switch (value) {
    case "T":
      if (rhythmus > 0) {
        return ` ${rhythmus * 7}-tägig`;
      }
      return " wtl.";
    case "E": return " einmalig";
    case "M": return " mtl.";
    case "M2": return " 2-mtl.";
    case "Q": return " 3-mtl.";
    case "M4": return " 4-mtl.";
    case "H": return " 6-mtl.";
    case "J": return "/Jahr";
    default: throw new UnreachableVariantError(value);
  }
}

export function abbuchungsintervallMonths(value: AbbuchungsintervallKurz): t.Int {
  switch (value) {
    case "T": return 0 as t.Int;
    case "E": return 0 as t.Int;
    case "M": return 1 as t.Int;
    case "M2": return 2 as t.Int;
    case "Q": return 3 as t.Int;
    case "M4": return 4 as t.Int;
    case "H": return 6 as t.Int;
    case "J": return 12 as t.Int;
    default: throw new UnreachableVariantError(value);
  }
}